module.exports = "/assets/3a5822e6857399a11a3195e27bcf87d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6Y.png
// module id = 1102
// module chunks = 0